import BaseFooter from './Footer';

// EXPORT
export const Footer = BaseFooter;
export type { FooterProps } from './Footer.interface';
